import { render } from "./AdminDiscountCodes.vue?vue&type=template&id=594a3704&scoped=true"
import script from "./AdminDiscountCodes.vue?vue&type=script&lang=js"
export * from "./AdminDiscountCodes.vue?vue&type=script&lang=js"

import "./AdminDiscountCodes.vue?vue&type=style&index=0&id=594a3704&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594a3704"]])

export default __exports__